import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8c49c3a8")

_pushScopeId("data-v-8c49c3a8")
const _hoisted_1 = { class: "carInfo" }
const _hoisted_2 = { class: "carInfo_card" }
const _hoisted_3 = { class: "infoList" }
const _hoisted_4 = { class: "infoListItem_name w140" }
const _hoisted_5 = { class: "infoListItem_value" }
const _hoisted_6 = { class: "carInfo_card" }
const _hoisted_7 = { class: "infoList" }
const _hoisted_8 = { class: "infoListItem_name w226" }
const _hoisted_9 = { class: "infoListItem_value" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_componentTitle = _resolveComponent("componentTitle")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_componentTitle, { title: "车辆信息" }),
      _createVNode("ul", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.baseInfo, (item) => {
          return (_openBlock(), _createBlock("li", {
            class: "infoListItem",
            key: item.fieldCode
          }, [
            _createVNode("span", _hoisted_4, _toDisplayString(item.fieldName), 1),
            _createVNode("span", _hoisted_5, _toDisplayString(item.fieldValue || '--'), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_componentTitle, { title: "配置信息" }),
      _createVNode("ul", _hoisted_7, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.configInfo, (item) => {
          return (_openBlock(), _createBlock("li", {
            class: "infoListItem",
            key: item.fieldCode
          }, [
            _createVNode("span", _hoisted_8, _toDisplayString(item.fieldName), 1),
            _createVNode("span", _hoisted_9, _toDisplayString(item.fieldValue || '--'), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
})